import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../config';
import { toast } from 'react-toastify';

const Customers = () => {
    const navigate = useNavigate();
    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [orders, setOrders] = useState([]);

    // Fetch data from backend
    useEffect(() => {
        fetchCustomers();
        fetchorders();
    }, []);

    useEffect(()=>{
        // console.log(customers);
        customers.map((cust) =>{
            console.log(cust.custName);
            
        })
    },[customers]);

    const fetchCustomers = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/customershowa`);
            const data = await response.json();
            setCustomers(data);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching customers:", error);
            setLoading(false);
        }
    };

    const fetchorders = async ()=>{
        try {
            const response = await fetch (`${API_BASE_URL}/ordershowa`);
            const data = await response.json();
            setOrders(data);
            setLoading(false);
        } catch (error) {
            toast.error("Error fetching Orders",error);
            setLoading(false);
        }
    };
    // --- DELETE FUNCTION ---
    const deleteCustomer = async (id, name) => {
        const confirmDelete = window.confirm(`Are you sure you want to delete ${name}?`);
        
        if (confirmDelete) {
            try {
                const response = await fetch(`${API_BASE_URL}/delete-customer/${id}`, {
                    method: 'DELETE',
                });
                if (response.ok) {
                    setCustomers(customers.filter(c => c._id !== id));
                } else {
                    alert("Failed to delete customer");
                }
            } catch (error) {
                console.error("Delete Error:", error);
            }
        }
    };

    // Filter customers based on Search
    const filteredCustomers = customers.filter(c => 
        c.custName.toLowerCase().includes(searchTerm.toLowerCase()) || 
        c.custPhone.includes(searchTerm)
    );

    return (
        <div className="container-fluid py-5 bg-light min-vh-100">
            {/* Import Icons if not already in index.html */}
            <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css" />
            
            <style>
                {`
                    .customer-card { border: none; border-radius: 15px; box-shadow: 0 10px 30px rgba(0,0,0,0.05); background: #fff; }
                    .table thead th { background-color: #f8f9fa; text-transform: uppercase; font-size: 0.75rem; letter-spacing: 1px; color: #6c757d; border-bottom: 2px solid #eef2f7; }
                    .table tbody td { vertical-align: middle; font-size: 0.9rem; color: #495057; border-bottom: 1px solid #f1f4f8; padding: 1rem 0.75rem; }
                    .search-input { border-radius: 10px; border: 1px solid #e0e6ed; padding: 0.6rem 1.2rem; }
                    .badge-gender { font-size: 0.7rem; padding: 0.4em 0.8em; border-radius: 6px; font-weight: 600; }
                    .measurement-pill { background: #eef2f7; color: #0d6efd; font-size: 0.75rem; padding: 2px 8px; border-radius: 4px; font-weight: 700; margin-right: 4px; display: inline-block; }
                    
                    /* FIXED BUTTON VISIBILITY */
                    .btn-action { 
                        width: 38px; 
                        height: 38px; 
                        padding: 0; 
                        border-radius: 8px; 
                        display: inline-flex; 
                        align-items: center; 
                        justify-content: center; 
                        margin-right: 8px; 
                        transition: all 0.2s;
                        border: 1px solid #eee;
                        background-color: white;
                        font-size: 1.1rem;
                    }
                    .btn-edit:hover { background-color: #e7f1ff; color: #0d6efd; border-color: #0d6efd; }
                    .btn-whatsapp:hover { background-color: #e9f7ef; color: #198754; border-color: #198754; }
                    .btn-delete:hover { background-color: #fff5f5; color: #dc3545; border-color: #dc3545; }
                `}
            </style>

            <div className="container">
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 gap-3">
                    <div>
                        <h2 className="fw-bold mb-0">Customer <span className="text-primary">Database</span></h2>
                        <p className="text-muted small mb-0">Manage measurement profiles.</p>
                    </div>
                    <div className="d-flex gap-2">
                        <input 
                            type="text" 
                            className="form-control search-input shadow-sm" 
                            placeholder="Search name or phone..." 
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <button onClick={() => navigate('/add-customer')} className="btn btn-primary fw-bold px-4 rounded-pill shadow-sm">
                            + Add New
                        </button>
                    </div>
                </div>

                <div className="card customer-card overflow-hidden">
                    <div className="table-responsive">
                        <table className="table table-hover mb-0">
                            <thead>
                                <tr>
                                    <th className="ps-4">Details</th>
                                    <th>Gender</th>
                                    <th>Shirt (L/C/W/H)</th>
                                    <th>Salwar (L/M)</th>
                                    <th>Location</th>
                                    <th className="text-center pe-4" style={{width: "180px"}}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="6" className="text-center py-5">
                                            <div className="spinner-border text-primary" role="status"></div>
                                        </td>
                                    </tr>
                                ) : filteredCustomers.length > 0 ? (
                                    filteredCustomers.map((c) => (
                                        <tr key={c._id}>
                                            <td className="ps-4">
                                                <div className="fw-bold text-dark">{c.custName}</div>
                                                <div className="small text-muted">{c.custPhone}</div>
                                            </td>
                                            <td>
                                                <span className={`badge badge-gender ${c.gender === 'Female' ? 'bg-danger-subtle text-danger' : 'bg-primary-subtle text-primary'}`}>
                                                    {c.gender}
                                                </span>
                                            </td>
                                            <td>
                                                <span className="measurement-pill">{c.measurements?.shirt?.length || '-'}</span>
                                                <span className="measurement-pill">{c.measurements?.shirt?.chest || '-'}</span>
                                                <span className="measurement-pill">{c.measurements?.shirt?.waist || '-'}</span>
                                                <span className="measurement-pill">{c.measurements?.shirt?.hip || '-'}</span>
                                            </td>
                                            <td>
                                                <span className="measurement-pill bg-success-subtle text-success">{c.measurements?.salwar?.salwarLength || '-'}</span>
                                                <span className="measurement-pill bg-success-subtle text-success">{c.measurements?.salwar?.mohri || '-'}</span>
                                            </td>
                                            <td>
                                                <div className="small">{c.address?.city || 'N/A'}</div>
                                            </td>
                                            <td className="text-center pe-4">
                                                {/* EDIT BUTTON */}
                                                <button 
                                                    className="btn-action btn-edit text-primary" 
                                                    onClick={() => navigate(`/edit-customer/${c._id}`)}
                                                    title="Edit Customer"
                                                >
                                                    <i className="bi bi-pencil-square"></i>
                                                </button>

                                                {/* WHATSAPP BUTTON */}
                                                <button 
                                                    className="btn-action btn-whatsapp text-success" 
                                                    onClick={() => window.open(`https://wa.me/${c.custPhone}`, '_blank')}
                                                    title="WhatsApp"
                                                >
                                                    <i className="bi bi-whatsapp"></i>
                                                </button>

                                                {/* DELETE BUTTON */}
                                                <button 
                                                    className="btn-action btn-delete text-danger" 
                                                    onClick={() => deleteCustomer(c._id, c.custName)}
                                                    title="Delete Customer"
                                                >
                                                    <i className="bi bi-trash3-fill"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="6" className="text-center py-5">No customers found.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Customers;